<template>
    <div>
        <!--        <navTitle :title="$router.app._route.query.ti ? $router.app._route.query.ti : 'Hash Game'"></navTitle>-->
        <div class="exchange">
            <div class="title">pertukaran cepat</div>
            <div class="exchange-area">
                <div class="arrow" @click="exchangeArrow">
                    <svg v-if="change_icon" t="1662344684502" class="icon" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="2436" width="64" height="64"
                         data-spm-anchor-id="a313x.7781069.0.i6">
                        <path d="M992 608l-960 0C12.8 608 0 620.8 0 640s12.8 32 32 32l883.2 0-230.4 230.4c-12.8 12.8-12.8 32 0 44.8C684.8 960 697.6 960 704 960s19.2 0 25.6-6.4l288-288C1024 652.8 1024 640 1024 627.2 1017.6 614.4 1004.8 608 992 608z"
                              p-id="2437" data-spm-anchor-id="a313x.7781069.0.i1" class="" fill="#e6e6e6"></path>
                        <path d="M32 416l960 0C1011.2 416 1024 403.2 1024 384s-12.8-32-32-32L108.8 352l230.4-230.4c12.8-12.8 12.8-32 0-44.8S307.2 64 294.4 70.4L6.4 358.4C0 371.2 0 384 0 396.8 6.4 409.6 19.2 416 32 416z"
                              p-id="2438" data-spm-anchor-id="a313x.7781069.0.i0" class="selected"
                              fill="#2c2c2c"></path>
                    </svg>
                    <svg v-else t="1662344684502" class="icon" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="2436" width="64" height="64"
                         data-spm-anchor-id="a313x.7781069.0.i6">
                        <path d="M992 608l-960 0C12.8 608 0 620.8 0 640s12.8 32 32 32l883.2 0-230.4 230.4c-12.8 12.8-12.8 32 0 44.8C684.8 960 697.6 960 704 960s19.2 0 25.6-6.4l288-288C1024 652.8 1024 640 1024 627.2 1017.6 614.4 1004.8 608 992 608z"
                              p-id="2437" data-spm-anchor-id="a313x.7781069.0.i1" class="selected"
                              fill="#2c2c2c"></path>
                        <path d="M32 416l960 0C1011.2 416 1024 403.2 1024 384s-12.8-32-32-32L108.8 352l230.4-230.4c12.8-12.8 12.8-32 0-44.8S307.2 64 294.4 70.4L6.4 358.4C0 371.2 0 384 0 396.8 6.4 409.6 19.2 416 32 416z"
                              p-id="2438" data-spm-anchor-id="a313x.7781069.0.i0" class="" fill="#e6e6e6"></path>
                    </svg>
                </div>
                <div style="clear: both"></div>
                <div class="exchange-con trx">
                    <div class="currency-title">{{change_icon===false?'TRX':'IDR'}}</div>
                    <input v-model="v1" placeholder="Masukkan jumlah"/>
                </div>
                <div class="exchange-con currency">
                    <div class="currency-title">{{change_icon===false?'IDR':'TRX'}}</div>
                    <input class="pr" v-model="v2" readonly/>
                </div>
            </div>
        </div>
        <div class="ex-rate-title">Kurs</div>
        <div class="exchange-rate">
            <div v-if="change_icon">1 IDR ≈ {{exchange_rate}} TRX</div>
            <div v-else>1 TRX ≈ {{exchange_rate}} IDR</div>
        </div>
        <div class="pay-btn bg-color-blue" @click="exchangeNow">Rp➜TRX Tebus sekarang</div>
        <div class="pay-btn bg-color-blue" @click="$router.push('/trx-recharge')">TRX➜Rp isi ulang</div>

        <div class="ex-rate-title">Pertukaran catatan</div>
        <div class="exchange-list" v-for="item in trx_list">
            <div class="exchange-arr">
                {{parseFloat(item.exchange_rate)<1?'IDR ➜ TRX':'TRX ➜ IDR'}}<br>
                <i class="order_id">{{item.order_id}}</i>
                <b class="exchange-status no_pro" v-if="item.status===0">tidak diproses</b>
                <b class="exchange-status under_review" v-if="item.status===1">sedang ditinjau</b>
                <b class="exchange-status success" v-if="item.status===2">kesuksesan</b>
                <b class="exchange-status fail" v-if="item.status===3">penukaran gagal</b>
            </div>
            <div class="time-hn"><i class="time">{{item._add_time}}</i><b class="hn">kurs:{{item.exchange_rate}}</b></div>
        </div>
        <div class="list-bottom"></div>
        <!--余额兑换TRX-->
        <div v-if="bg_flag" class="dialog-balance-trx">
            <div class="row-wrap">
                <div class="row">IDR ➜ TRX</div>
                <div class="row">
                    <div class="row-name">Saldo(Rp)</div>
                    <input class="input" v-model="balance" readonly/>
                </div>
                <div class="row">
                    <div class="row-name">Menarik(TRX)</div>
                    <input class="input" type="number" v-model="trx.amount" placeholder="menukarkan(TRX)"/>
                </div>
                <div class="rate-show" v-if="trx.amount>=0">{{trx.amount}}<i> TRX</i> ≈
                    {{Math.round(exchange_rate*trx.amount)}}<i> Rp</i></div>
                <div class="pay-btn bg-color-blue" @click="balanceToTRX">Tentu</div>
            </div>
        </div>
        <div id="forPop" v-if="bg_flag" @click="bgClose"></div>
    </div>
</template>

<script>
    // import navTitle from "@components/navTitle"
    import {getExchangeRate, DebounceBy, addWithdraw, getTRXList} from "../../api/trx"
    import {getUser} from "@api/user"

    export default {
        name: "hash-game.vue",
        // trxRecharge
        data() {
            return {
                change_icon: true,
                exchange_rate: 0,
                bg_flag: false,
                v1: '',
                v2: '',
                balance: 0,
                trx: {
                    amount: 0
                },
                trx_list: []
            };
        },
        created() {
            this.exchangeArrow()
            this.getTRXList()
        },
        watch: {
            v1: function (n) {
                this.v2 = parseFloat(n) * parseFloat(this.exchange_rate)
                if (n === '')
                    this.v2 = ''
            }
        },
        methods: {
            exchangeArrow() {
                this.v1 = ''
                this.v2 = ''
                this.change_icon = !this.change_icon
                let that = this
                getExchangeRate({type: this.change_icon === false ? 0 : 1}).then(res => {
                    that.exchange_rate = res.data.current_rate
                    console.log(res)
                }).catch(err => {
                    console.log(err)
                })
            },
            bgClose() {
                this.bg_flag = false
            },
            // 立即兑换
            exchangeNow() {
                this.bg_flag = true
                this.getUserInfo()
                this.change_icon = true
                this.exchangeArrow()
                console.log(1111)
            },
            getUserInfo() {
                let that = this
                getUser().then(res => {
                    that.balance = res.data.now_money;
                });
            },
            // 余额兑换TRX
            balanceToTRX: DebounceBy(function () {
                let rp_amount = Math.round(this.exchange_rate * this.trx.amount)
                let trx_amount = this.trx.amount
                if (this.balance < rp_amount)
                    return this.$dialog.toast({mes: 'Saldo tidak mencukupi'})
                let param = {
                    trx_amount: trx_amount
                }
                let that = this
                addWithdraw(param).then(res => {
                    console.log(res)
                    that.bgClose()
                    that.getTRXList()
                    that.$dialog.toast({mes: res.msg})
                }).catch(err => {
                    console.log(err)
                })
            }, 3000),
            getTRXList() {
                let that = this
                getTRXList().then(res => {
                    that.trx_list = res.data
                    console.log(res)
                }).catch(err => {
                    console.log(err)
                })
            }
        }
    }
</script>

<style scoped>
    .exchange {
        margin-top: 1rem;
        width: 100%;
        height: 200px;
        background: linear-gradient(to right, rgba(255, 204, 204, .25), rgba(204, 204, 255, .25));
    }

    .title {
        padding: 3%;
        font-size: .4rem;
    }

    .exchange-con {
        width: 50%;
        height: 100px;
        /*float: left;*/
        /*border: 1px solid red;*/
    }

    .exchange-con input {
        margin-top: .25rem;
    }

    .exchange-area {
        position: relative;
        width: 96%;
        margin: 0 2%;
        padding: 1%;
        border-radius: .1rem;
        background: #fff;
    }

    .trx {
        padding: .2rem;
        font-weight: bold;
        border-right: 1px dashed #ddd;
    }

    .currency {
        padding: .2rem;
        font-weight: bold;
        float: right;
        margin-top: -100px;
        text-align: right;
        border-left: 1px dashed #ddd;
    }

    .pr {
        text-align: right;
        float: right;
    }

    .arrow {
        position: absolute;
        left: 44%;
        top: 24%;
        width: 50px;
        height: 50px;
        border-radius: 32px;
        text-align: center;
        background: #fff;
        box-shadow: 5px 5px 12px #333;
    }

    .icon {
        margin-top: 10px;
        font-size: 32px
    }

    .ex-rate-title {
        padding: 2%;
    }

    .exchange-rate {
        width: 96%;
        margin: 0 2%;
        padding: 2%;
        text-align: right;
        background: #F8F8FF;
        border-radius: .1rem;
    }

    .bg-color-blue {
        color: #fff;
        margin: .3rem 2%;
        width: 96%;
        text-align: center;
        font-size: .5rem;
        padding: .1rem 0;
        border-radius: .1rem;
    }

    .exchange-list {
        width: 96%;
        margin: .15rem 2%;
        padding: 2%;
        background: #F8F8FF;
        border-radius: .1rem;
    }

    .exchange-arr {
        color: #333;
        padding: .15rem .1rem;
        width: 100%;
    }

    .exchange-status {
        float: right
    }

    .no_pro {
        color: darkgrey;
    }

    .under_review {
        color: orange;
    }

    .success {
        color: #0DCE5D;
    }

    .fail {
        color: red;
    }

    .time-hn {
        width: 100%;
        border-top: 1px dashed #d4d8dd;
        padding: .1rem;
        font-size: .25rem;
        color: #d4d8dd;
    }

    .hn {
        float: right;
    }

    /*弹窗*/
    #forPop {
        z-index: 999;
        width: 100%;
        height: 1000px;
        top: 0px;
        left: 0px;
        position: absolute;
        /*因为IE不支持opacity 所以用filter 为了兼容两个都写*/
        filter: Alpha(opacity=60);
        opacity: 0.6;
        background: #000000;
    }

    .row {
        width: 100%;
        padding: 0 0.27rem;
        box-sizing: border-box;
        background: #fff;
        height: 0.75rem;
        line-height: 0.75rem;
        display: flex;
        position: relative;
    }

    .row::after {
        content: "";
        position: absolute;
        width: calc(100% - 0.27rem - 0.27rem);
        bottom: 0px;
        left: 0;
        right: 0;
        margin: 0 auto;
        height: 1px;
        background: #eee;
    }

    .row .row-name {
        width: 2.5rem;
    }

    .row .input {
        flex: 1;
        display: block;
        height: 0.75rem;
        line-height: 0.75rem;
        box-sizing: border-box;
        padding-left: 0.15rem;
        border: none;
        background: #fff;
    }

    .dialog-balance-trx {
        z-index: 1000;
        background-color: #fff;
        width: 350px;
        height: 270px;
        border-radius: 5px;
        position: fixed;
        left: 50%;
        top: 50%;
        margin-top: -210px;
        margin-left: -175px;
        padding-top: 10px;
    }

    .rate-show {
        margin-top: .3rem;
        color: #333333;
        text-align: center;
        font-size: .3rem;
    }

    .rate-show i {
        color: red;
        font-size: .1rem
    }

    .list-bottom {
        height: .3rem;
    }

    .order_id {
        font-size: .1rem;
        padding: 2px 0
    }
</style>